require('offline-js')

export default window.Offline
